export enum AnnotationSource {
  User,
  Nlp,
}

